import { render, staticRenderFns } from "./Competitors.pug?vue&type=template&id=549d41ae&scoped=true&lang=pug&external"
import script from "./Competitors.js?vue&type=script&lang=js&external"
export * from "./Competitors.js?vue&type=script&lang=js&external"
import style0 from "./Competitors.vue?vue&type=style&index=0&id=549d41ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d41ae",
  null
  
)

export default component.exports